import { formatISO } from 'date-fns';

export function updateUser(updates, checkBoxes, pwdReset, userIn) {
    const userOut = (userIn ? userIn : {});
    if (typeof updates !== 'undefined') {
        userOut.username = updates.username;
        userOut.password = updates.password;
        userOut.agencyId = updates.agency;
        userOut.firstName = updates.firstName;
        userOut.middleName = updates.middleName;
        userOut.lastName = updates.lastName;
        userOut.email = updates.email;
        userOut.phone = updates.phone;
        userOut.defaultTerminal = updates.defaultTerminal;
        userOut.location = updates.location;
        userOut.notes = updates.notes;
        userOut.isUser = checkBoxes.userRole;
        userOut.isManager = checkBoxes.managerRole;
        userOut.isAdmin = checkBoxes.adminRole;
        userOut.isJsi = checkBoxes.jsiRole;
        userOut.isOs = checkBoxes.osRole;
        userOut.enabled = checkBoxes.enabled;
        userOut.accountLocked = checkBoxes.accountLocked;
        userOut.passwordExpired = checkBoxes.passwordExpired;
        if (updates.externalId) userOut.externalId = updates.externalId;
        if (pwdReset) userOut.lastPasswordReset = formatISO(pwdReset, {representation: 'date'});
    }
    return userOut;
}
